import { useState, useMemo } from 'react';

export function useSortable(rows, accessors = {}) {
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState('asc');

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  const sortedRows = useMemo(() => {
    if (!sortKey || !rows) return rows || [];
    const getVal = accessors[sortKey] ?? ((r) => r[sortKey]);
    return [...rows].sort((a, b) => {
      let av = getVal(a) ?? '';
      let bv = getVal(b) ?? '';
      if (typeof av === 'number' && typeof bv === 'number') {
        return sortDir === 'asc' ? av - bv : bv - av;
      }
      av = String(av).toLowerCase();
      bv = String(bv).toLowerCase();
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  }, [rows, sortKey, sortDir, accessors]);

  return { sortKey, sortDir, handleSort, sortedRows };
}

export function SortTh({ label, sortKey, currentKey, currentDir, onSort, style, children }) {
  const isActive = currentKey === sortKey;
  return (
    <th
      onClick={() => onSort(sortKey)}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap', ...style }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {label ?? children}
        <span style={{ fontSize: 10, opacity: isActive ? 1 : 0.25, lineHeight: 1 }}>
          {isActive && currentDir === 'desc' ? '▼' : '▲'}
        </span>
      </span>
    </th>
  );
}
